import axios from "axios"

const fetchData = async (url, page, per_page) => {
   const res = await axios.get(url, {
      params: {
         page: `${page}`,
         per_page: `${per_page}`
      }
   }).then((res) => { 
      return res.data
   }).catch((err) => {
      console.log(err)
   });

   return res;
}


export { fetchData}